<template>
    <!-- App -->
    <f7-app
        :params="f7params"
        :class="darkTheme && user.id ? 'theme-dark' : ''"
    >
        <f7-panel left>
            <f7-view
                id="left"
                name="left"
            >
                <f7-page>
                    <f7-navbar title="Left" />
                </f7-page>
            </f7-view>
        </f7-panel>
        <f7-appbar
            v-if="!isPgap && isMobile && !isDev"
            style="z-index: 70000;"
        >
            <div class="left">
                <f7-link
                    external
                    href="https://getcoral.app/download"
                >GET THE APP</f7-link>
            </div>
            <div class="right">
                <f7-link
                    :href="getDeeplink"
                    external
                >OPEN IN APP</f7-link>
            </div>
        </f7-appbar>
        <f7-view
            id="main"
            name="main"
            url="/"
            main
        >
            <f7-page>
                <f7-navbar title="Coral" />
            </f7-page>
        </f7-view>

        <f7-view
            id="offline"
            :dynamic-navbar="true"
            name="offline"
            no-navbar
            offline
            style="display: none"
        >
            <f7-page name="init">
                <f7-navbar title="Offline" />
            </f7-page>
        </f7-view>
        <f7-popup
            id="popup"
            :style="`${!isPgap && isMobile && !isDev ? 'margin-top: 44px;':''}`"
        >
            <f7-view
                name="popup"
                url="/blank"
            >
                <f7-page />
            </f7-view>
        </f7-popup>
        <f7-popup
            id="popup2"
            :style="`${!isPgap && isMobile && !isDev ? 'margin-top: 44px;':''}`"
        >
            <f7-view
                name="popup2"
                url="/blank"
            >
                <f7-page />
            </f7-view>
        </f7-popup>
        <f7-popup
            id="popup3"
            :style="`${!isPgap && isMobile && !isDev ? 'margin-top: 44px;':''}`"
        >
            <f7-view
                name="popup3"
                url="/blank"
            >
                <f7-page />
            </f7-view>
        </f7-popup>
        <audio style="display: none" />
        <global-audio
            v-if="audioSources.length"
            :sources="audioSources"
            :loop="false"
            :volume="1"
        />
        <global-user
            v-if="f7Ready"
            :url="launchUrl"
        />
        <global-analytics v-if="f7Ready" />
        <global-data v-if="f7Ready" />
        <global-notifications v-if="f7Ready" />
        <global-subscriptions v-if="f7Ready" />
    </f7-app>
</template>

<script>
import cordovaApp from '../js/cordova-app.js';
import Routes from '../js/routes';
import utils from '../js/utils';

import globalAudio from './global/audio.vue';
import globalAnalytics from './global/analytics.vue';
import globalData from './global/data.vue';
import globalUser from './global/user.vue';
import globalNotifications from './global/notifications.vue';
import globalSubscriptions from './global/subscriptions.vue';

let url = window.initUrl
    ? window.initUrl.replace('/web/', '')
    : window.location.href.replace('http://localhost:8601/', '/web').slice(window.location.href.indexOf('/web/') + 5);
if (
    url === '/' ||
    url === 's://getcoral.app/web' ||
    url === 's://staging.getcoral.app/web' ||
    url === '//web' ||
    url.indexOf('/var/mobile/Containers/') > -1 ||
    url.indexOf('/var/containers/Bundle') > -1
)
    url = false;
if (url && url.indexOf('/files/cordova-hot-code-push-plugin/') > -1) url = false;

export default {
    components: {
        globalAudio,
        globalAnalytics,
        globalData,
        globalUser,
        globalNotifications,
        globalSubscriptions
    },
    data () {
        return {
            f7Ready: false,
            f7params: {
                // Array with app routes
                routes: Routes,
                // App Name
                name: 'Coral',
                // App id
                id: 'app.coral.m',
                // Enable swipe panel
                panel: {
                    // do this manually after start so login can be fullscreen
                    // leftBreakpoint: 768,
                },
                theme: 'ios', // change to auto maybe
                // Register service worker
                serviceWorker: this.$device.cordova
                    ? {}
                    : {
                        // path: '/service-worker.js'
                    },
                // Input settings
                input: {
                    scrollIntoViewOnFocus: !!window.cordova,
                    scrollIntoViewCentered: !!window.cordova
                },
                // Cordova Statusbar settings
                statusbar: {
                    overlay: (this.$device.cordova && this.$device.ios) || 'auto',
                    iosTextColor: 'black',
                    iosOverlaysWebView: true,
                    androidOverlaysWebView: false,
                    scrollTopOnClick: !this.exploreCardOpen
                },
                touch: {
                    activeStateElements: 'a, button, label, span, .actions-button, .hasActive'
                }
            }
        };
    },
    computed: {
        isDev: function () {
            return (location.hostname === "localhost" || location.hostname === "127.0.0.1");
        },
        launchUrl: function () {
            return url;
        },
        isPgap: function () {
            return pgap;
        },
        isMobile: function () {
            var isMobile = false;
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                    navigator.userAgent
                ) ||
                // eslint-disable-next-line no-useless-escape
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    navigator.userAgent.substr(0, 4)
                )
            )
                isMobile = true;
            return isMobile;
        },
        getDeeplink: function () {
            return 'coral://' + location.pathname;
        }
    },
    store: [
        'api',
        'user',
        'offline',
        'currentTab',
        'audioSources',
        'exploreCardOpen',
        'darkTheme',
        'fontSize',
        'onboardingCompleted',

    ],
    created: function () {
        console.log('Window url:', url);
        // both logged an unlogged
        let variant = 1;
        console.log('[variant] 014_goals', variant)
        localStore.setItem(`experiment-014_goals`, variant)
        let variant2 = parseFloat(localStore.getItem(`experiment-015_course-nav`));
        console.log('[variant] 015_course-nav`', variant2)
        if (isNaN(variant2) || variant2 > 1) {
            const variants2 = 2;
            variant2 = Math.floor(Math.random() * (variants2));
            localStore.setItem(`experiment-015_course-nav`, variant2)
            setTimeout(() => {
                this.$events.fire('trackExperiment', '015_course-nav', variant2);
            }, 5000);
        }
        let variant3 = parseFloat(localStore.getItem(`experiment-016_explore-names`));
        console.log('[variant] 016_explore-names`', variant3)
        if (isNaN(variant3) || variant3 > 2) {
            const variants3 = 3;
            variant3 = Math.floor(Math.random() * (variants3));
            localStore.setItem(`experiment-016_explore-names`, variant3)
            setTimeout(() => {
                this.$events.fire('trackExperiment', '016_explore-names', variant3);
            }, 5000);
        }
    },
    mounted () {
        if (window.Sentry) {
            window.Sentry.configureScope(scope => {
                scope.setTag('appversion', window.version);
            });
        }
        this.$f7ready(f7 => {
            window.f7 = f7;
            this.f7Ready = true;
            // 0. Boot native stuff if on mobile
            if (window.pgap) {
                console.log('setup cordova');
                cordovaApp.init(f7);
            }
            // 1. Launch cookie auth from firebase
            // Now all this is in globalUser
            // 2. Track devices as a user could have several for push etc..
            setTimeout(() => {
                this.restoreStore();
                if (!localStore.getItem('uuid')) {
                    this.registerDevice();
                } else {
                    Vue.http.headers.common.uuid = localStore.getItem('uuid');
                }

                Vue.http.interceptors.push(request => {
                    // modify request
                    request.headers.set('app-version', window.version);
                    // return response callback
                    return response => {
                        // modify response
                        if ([408, 503].indexOf(response.status) > -1) {
                            utils.failedRequest('main', response);
                        } else if ([401].indexOf(response.status) > -1) {
                            console.log('Invalid auth')
                            if (response.body && response.body.message &&
                                (

                                    response.body.message === 'Expired authentication token.'
                                )
                            ) {
                                utils.failedRequest('main', response);
                            }
                            if (response.body && response.body.message &&
                                (

                                    response.body.message === 'Invalid user permissions and uid.'
                                )
                            ) {
                                localStore.removeItem('uuid');
                                localStore.removeItem('jwt');
                                localStore.removeItem('notifications-push');
                                try {
                                    if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.auth) {
                                        cordova.plugins.firebase.auth.signOut();
                                    } else if (window.firebase) {
                                        window.firebase
                                            .auth()
                                            .signOut()
                                    }
                                } catch (e) {
                                    console.error("Could not sign out of firebase");
                                }
                                if (pgap) {
                                    window.location.reload();
                                } else {
                                    window.location.href = '/';
                                }
                            }
                        }
                    }
                });
            }, 0);
            // 3. Get raw data files
            // Now all this is in globalData
            // this.getTraits();
            // this.getTopics();
            // this.getCourses();
            // this.getUnits();
            // 4. Launch required views and layout things
            setTimeout(() => {
                this.boot();
            }, 300);
        });
    },
    methods: {
        boot: function () {
            // I do this so that all the views are loaded after load
            // so all things are available.
            // This one never changes
            if (this.$f7.views['left']) {
                this.$f7.views['left'].router.navigate({ url: '/menu', reload: true, animatePages: true });
            }
            if (this.$f7.views['offline']) {
                this.$f7.views['offline'].router.navigate({ url: '/offline', reload: true, animatePages: true });
            }
            // main view router behaves differently as it may have multiple views
            const mainView = this.$f7.views['main'];
            mainView.main = true;
            mainView.params.stackPages = true;
            mainView.params.pushState = pgap ? false : true;
            mainView.params.pushStateOnLoad = false;
            mainView.params.pushStateSeparator = '';
            mainView.params.pushStateRoot =
                location.hostname !== 'localhost' ? `https://${pgap ? 'getcoral.app' : location.hostname}/web` : 'http://localhost:8601/';

            mainView.on('routeChanged', e => {
                if (e.url && e.url.indexOf('/explore') > -1) {
                    this.currentTab = 'explore';
                } else if (e.url && e.url.indexOf('/profile') > -1) {
                    this.currentTab = 'profile';
                } else if (e.url && e.url === '/goals') {
                    this.currentTab = 'goals';
                }
                this.$events.fire('pageChange', e);
            });

            if (url && url === 'web') url = false;
            if (url) url = url.replace('//', '');
            if (pgap) url = false;
            if (url && ['/login', '/register'].indexOf(url) > -1) {
                mainView.router.navigate(url, { clearPreviousHistory: true, animate: false });
            } else if (url && (url.indexOf('/units/') > -1 || url.indexOf('/comments/') > -1)) {
                setTimeout(() => {
                    //slow this down for authentication
                    setTimeout(() => {
                        this.$f7.popup.get('#popup').close();
                        this.$f7.popup.get('#popup2').close();
                        this.$f7.popup.get('#popup3').close();
                        this.$f7.popup.get('#popup').open();
                    }, 400);
                    this.$f7.views['popup'].router.navigate(url, { clearPreviousHistory: true, animate: false });
                }, 400);
                if (!pgap) window.history.pushState(null, "", '/web' + url);
            }

            // popup router too
            this.$f7.views['popup'].on('routeChanged', e => {
                this.$events.fire('pageChange', e);
                if (!pgap) window.history.pushState(null, "", '/web' + e.path);
            });
            this.$f7.views['popup2'].on('routeChanged', e => {
                this.$events.fire('pageChange', e);
                if (!pgap) window.history.pushState(null, "", '/web' + e.path);
            });
            this.$f7.views['popup3'].on('routeChanged', e => {
                this.$events.fire('pageChange', e);
                if (!pgap) window.history.pushState(null, "", '/web' + e.path);
            });
            window.addEventListener('popstate', function (ev) {
                ev.preventDefault();
                if (mainView && mainView.router && mainView.router.back)
                    mainView.router.back();
                // if popup is open do it in popup?
            });
            if (localStore.getItem('jwt') && localStore.getItem('uuid')) {
                Vue.http.headers.common.uuid = localStore.getItem('uuid');
                Vue.http.headers.common.jwt = localStore.getItem('jwt');
            }
            // This is hacky but works!
            // DO not touch, took a long time to figure out
            const statusbarFix = () => {
                if (device.platform === 'Android') {
                    setTimeout(() => {
                        this.$f7.statusbar.show();
                        if (this.darkTheme || device.platform === 'Android') {
                            this.$f7.statusbar.setTextColor('white');
                        } else {
                            this.$f7.statusbar.setTextColor('black');
                        }
                    }, 100);
                } else {
                    this.$f7.statusbar.show();
                    this.$f7.statusbar.overlaysWebView(true);
                    if (this.darkTheme || device.platform === 'Android') {
                        this.$f7.statusbar.setTextColor('white');
                    } else {
                        this.$f7.statusbar.setTextColor('black');
                    }
                    setTimeout(() => {
                        this.$f7.statusbar.overlaysWebView(true);
                    }, 10);
                }
            };
            if (pgap) {
                document.addEventListener('online', () => {
                    console.log('Online event');
                    window.isOffline = false;
                });
                document.addEventListener(
                    'resume',
                    () => {
                        setTimeout(() => {
                            console.log('Resume event jwt refresh');
                        }, 10);
                        statusbarFix();
                    },
                    false
                );
                statusbarFix();
                window.addEventListener('keyboardDidShow', () => {
                    // iphones not X
                    statusbarFix();
                });
            }
            this.deepLinkProposal();
            // END statusbar hack
        },
        initBreakpoints: function () {
            let panel = f7.panel.get('.panel-left');
            panel.params.visibleBreakpoint = 768;
            panel.enableVisibleBreakpoint();
        },
        fadeSplash: function () {
            let splash = document.getElementById('splash');
            splash.className = 'fadeout afterFadeOut';
        },
        registerDevice: function (done) {
            let deviceType = pgap ? device.platform || (f7.device.ios ? 'iOS' : 'Android') : 'web';
            this.$http
                .post(this.api + '/devices', {
                    deviceType,
                    device: pgap ? device : { ua: window.navigator.userAgent }
                })
                .then(
                    response => {
                        this.data = response.body;
                        if (this.data.uuid) {
                            this.myDevice = this.data;
                            if (!localStore.getItem('uuid') && pgap)
                                this.$events.fire('trackEvent', 'authentication_install', 'authentication', 1, '');
                            localStore.setItem('uuid', this.myDevice.uuid);
                            Vue.http.headers.common.uuid = this.myDevice.uuid;
                            if (window.Branch) {
                                window.Branch.setRequestMetadata("coral_uuid", this.myDevice.uuid);
                            }
                        }
                        if (typeof done === 'function') done();
                    },
                    () => {
                        setTimeout(() => {
                            if (!localStore.getItem('uuid'))
                                this.registerDevice();
                        }, 1000);
                        console.error('Could not register device');
                    }
                );
        },
        restoreStore: function () {
            this.darkTheme = window.localStore && window.localStore.getItem('darkTheme') ? true : false;
            this.fontSize = (window.localStore && window.localStore.getItem('fontSize')) || 'normal';
            this.onboardingCompleted = window.localStore && window.localStore.getItem('onboardingCompleted')
                ? parseFloat(window.localStore.getItem('onboardingCompleted'))
                : 0;

            console.log("onboarding completed in the store is", this.onboardingCompleted);

        },
        deepLinkProposal: function() {
            try {
                if (utils.isMobile() && window.location.href.match(/web\/?$/)) {
                    const ua = navigator.userAgent.toLowerCase();
	                const isAndroid = ua.indexOf("android") > -1;
                    const url ="coral:///coral";
		            if (isAndroid) {
                        window.location.replace(url);
		            } else {
			            window.location.href = url;
		            }
	            }
            } catch (e) {
                alert(`Can't redirect to Coral Application.`);
            }
        },
    }
};
</script>
<style lang="less" scoped>
</style>
